export enum WarningType {
  ERROR = 'error',
  VALIDATED = 'validated',
  WARNING = 'warning',
}
